// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--L1ZnK","content":"header-module--content--3MT40","title":"header-module--title--EMxyd"};